export type Item = {
  key: string;
  label: string;
};

export type Group<T extends Item> = {
  group: string | null;
  items: T[];
};

export function isItem<T extends Item>(items: T[] | Group<T>[]): items is T[] {
  const item = items[0];
  if (item === undefined) {
    return true;
  }

  return !("items" in item);
}

export function toGroupList<T extends Item>(
  items: T[] | Group<T>[]
): Group<T>[] {
  if (isItem(items)) {
    return [{ group: null, items }];
  }
  return items;
}

export function toItemList<T extends Item>(items: T[] | Group<T>[]): T[] {
  if (isItem(items)) {
    return items;
  }
  return items.flatMap((group) => group.items);
}

export function filterItems<T extends Item>(items: T[], keyword: string): T[] {
  return items.filter((item) =>
    item.label.toLowerCase().includes(keyword.toLowerCase())
  );
}

export function filterGroups<T extends Item>(
  groups: Group<T>[],
  keyword: string
): Array<Group<T> & { originalIndex: number }> {
  return groups.flatMap((group, originalIndex) => {
    const itemsInGroup = filterItems(group.items, keyword);
    if (itemsInGroup.length === 0) {
      return [];
    }
    return [{ ...group, items: itemsInGroup, originalIndex }];
  });
}
